// extracted by css-extract-rspack-plugin
export default {"root":"xW5jpo","search-input":"MIfPWv","searchInput":"MIfPWv"};